let initialState={payload:{msg:'fetching',data:[]},action:"success"};
let listVehical =(state=initialState.payload,action)=>{
    switch(action.type){
        case "success":{
            state={
                data:action.payload,
                msg:'fetched'
            };
            break;
        }
        default:{}

    }
return state;
}

export default listVehical ;


// WEBPACK FOOTER //
// ./src/redux/reducers/vehicles/listVehicle.js